module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-right"
  }, [_c('img', {
    attrs: {
      "alt": "ink splotch",
      "src": "image/bloom.jpg"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "part_num",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("PART 1")]), _vm._v(" "), _c('h2', {
    staticClass: "part_name"
  }, [_vm._v("HENRY")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("A good man is a good man, whether in this church or out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "intro_attrib"
  }, [_vm._v("Brigham Young")]), _c('br'), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "Chapter-date"
  }, [_vm._v("Eight Weeks Earlier")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f84fa252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part1.vue
// module id = 69
// module chunks = 0